import React, { useState } from 'react';
import TextWithInputs from 'src/pages/reportUsage/common/textWithInputs/TextWithInputs';
import Checkbox from 'src/common/refactoredComponents/checkbox/Checkbox';
import {
    GridContainer,
    ItemDetailText,
    OnHandText,
    LoTtext,
    UsedBytext,
    UseByDate,
    ItemCardTextContainer,
    EAIcon,
    MdiOptions,
    NTIconContainer,
    NTIcon,
    TIconContainer,
    TIcon,
    MaxExpirytext,
    MaxExpiryDate,
} from './InventoryBody.styled';
import RedAlertIcon from 'src/assets/images/RedAlertIcon.svg';
import ClockAlertOutline from 'src/assets/images/ClockAlertOutline.svg';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { setInventoryItems } from '../../redux/actions';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
export default function InventoryBodyDesktop({
    user,
    handleChange,
    index,
    setQuantityValue,
    setItemDetails,
    clrAll,
    //key
}) {
    // debugger
    const dispatch = useDispatch();
    const [quantity, setQuantity] = useState('');
    const [checked, setChecked] = useState(false);
    const [quantityValidation, setQuantityyValidation] = useState(false);
    const checkedItemsBody = useSelector(
        (state) => state.inventoryReducer.checkedItems
    );
    const handleQtyValidation = (e, onHand, isChecked, index, uniqueKey) => {
        setQuantityValue(e.target.value);
        setItemDetails(index, e.target.value, uniqueKey);
        //setValidation(quantityValidation);
    };
    const { t } = useTranslation();
    const loading = useSelector((state) => state.inventoryReducer.loading);
    useEffectWithErrorLogging(() => {
        if (Object.prototype.hasOwnProperty.call(user, 'isChecked')) {
            const items = checkedItemsBody
                .filter((item) => item != undefined)
                .map((itemData) => ({
                    ...itemData,
                    flag: itemData.onHand < itemData.used ? true : false,
                }));
            if (user.isChecked) {
                checkedItemsBody &&
                    checkedItemsBody.map((item) => {
                        if (item.uniqueKey === user.uniqueKey) {
                            setQuantity(item.used);
                            errorValidation(item.used, item.onHand);
                            if (item.onHand < item.used) {
                                setQuantityyValidation(true);
                            } else {
                                setQuantityyValidation(false);
                            }
                        }
                    });
                setChecked(true);
            } else {
                setQuantity('');
                setChecked(false);
                setQuantityyValidation(false);
            }
        }
    }, [user?.isChecked]);
    const countryISOCode = useSelector(
        (state) => state.loginReducer.hybrisUserDetails.countryISOCode
    );

    const errorValidation = (value, onHand) => {
        if (value && value > onHand) {
            user.flag = true;
        } else {
            user.flag = false;
        }
    };

    return (
        <div>
            {loading == false ? (
                <GridContainer
                    container
                    justifyContent={'space-between'}
                    direction="row"
                >
                    <ItemCardTextContainer
                        item
                        xs={1}
                        sm={1}
                        md={1}
                        lg={1}
                        xl={1}
                        mobile={1}
                        key={index}
                        style={{
                            marginRight: '-60px',
                        }}
                    >
                        <Checkbox
                            name={user.lotSerial}
                            key={index}
                            value={user.uniqueKey}
                            checked={checked ? checked : user?.isChecked || false}
                            onCheckboxSelectionChange={(e) => handleChange(e, clrAll)}
                            id="consignmentBilling-inventory-InventoryBodyDesktop-lotSerial-checkbox"
                            margin={'2px 0 0 0'}
                            background={'none'}
                            checkboxBorder={'1.5px solid #555555'}
                            alignItemDirection={'center'}
                            hoverEffect={'false'}
                            disableFocusEffect={'true'}
                        />
                    </ItemCardTextContainer>
                    <ItemCardTextContainer
                        item
                        xs={12}
                        sm={3}
                        md={3}
                        lg={4}
                        xl={4}
                        mobile={12}
                        className={'DescGrid'}
                    >
                        <ItemDetailText isDemi>{user.cfn}</ItemDetailText>
                        <ItemDetailText isRegular>
                            {user.materialDesc}
                        </ItemDetailText>
                    </ItemCardTextContainer>
                    <ItemCardTextContainer
                        item
                        xs={12}
                        sm={1}
                        md={1}
                        lg={1}
                        xl={2}
                        mobile={12}
                    >
                        <div
                            style={{
                                display: 'flex',
                                marginTop: '3px',
                            }}
                        >
                            {countryISOCode === 'US' ? (
                                <div>
                                    {user.salesOrg === 'S030' ? (
                                        <TIconContainer>
                                            <TIcon>
                                                {t(
                                                    'consignmentBilling.inventory.t'
                                                )}
                                            </TIcon>
                                        </TIconContainer>
                                    ) : (
                                        <NTIconContainer>
                                            <NTIcon>
                                                {t(
                                                    'consignmentBilling.inventory.nt'
                                                )}
                                            </NTIcon>
                                        </NTIconContainer>
                                    )}
                                </div>
                            ) : null}
                            <EAIcon>
                                {user?.uom
                                    ? user.uom
                                    : t('consignmentBilling.inventory.ea')}
                            </EAIcon>
                        </div>
                    </ItemCardTextContainer>
                    <ItemCardTextContainer
                        item
                        xs={12}
                        sm={1}
                        md={1}
                        lg={1}
                        xl={1}
                        mobile={12}
                        style={{
                            marginTop: '-7px',
                        }}
                    >
                        <TextWithInputs
                            name={t('common.qty')}
                            placeholder={'0'}
                            maxLength={2}
                            inputHeight={'40px'}
                            inputWidth={'58px'}
                            alignText={'center'}
                            onkeyUp={(e) => {
                                setQuantity(
                                    e.target.value
                                        ? e.target.value.replace(/[^0-9]+/g, '')
                                        : ''
                                );
                                if (
                                    e.target.value &&
                                    e.target.value.length > 0 &&
                                    e.target.value > user.onHand
                                ) {
                                    setQuantityyValidation(true);
                                } else {
                                    setQuantityyValidation(false);
                                }
                                errorValidation(e.target.value, user.onHand);
                                handleQtyValidation(
                                    e,
                                    user.onHand,
                                    user.isChecked,
                                    index,
                                    user.uniqueKey
                                );
                            }}
                            errorMsg={
                                quantityValidation
                                    ? 'Quantity can\'t exceed On hand Quantity'
                                    : ''
                            }
                            inputBorder={
                                quantityValidation ? '2px solid #FACFD6' : ''
                            }
                            value={quantity}
                            key={index}
                        />
                    </ItemCardTextContainer>
                    <ItemCardTextContainer
                        item
                        xs={1}
                        sm={1}
                        md={1}
                        lg={1}
                        xl={1}
                        mobile={1}
                        style={{
                            paddingRight: '20px',
                        }}
                    >
                        <OnHandText>{user.onHand}</OnHandText>
                    </ItemCardTextContainer>
                    <ItemCardTextContainer
                        item
                        xs={12}
                        sm={1}
                        md={1}
                        lg={2}
                        xl={2}
                        mobile={12}
                        style={{
                            paddingLeft: '40px',
                            whiteSpace: 'nowrap',
                        }}
                    >
                        <LoTtext>{user.lotSerial}</LoTtext>
                    </ItemCardTextContainer>
                    <ItemCardTextContainer
                        item
                        xs={12}
                        sm={2}
                        md={2}
                        lg={1}
                        xl={1}
                        mobile={12}
                        align={'right'}
                        style={{
                            alignText: 'right',
                        }}
                    >
                        {user.expiryStatus === 'EXPIRED' ? (
                            <div>
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'flex-end',
                                        alignContent: 'center',
                                    }}
                                >
                                    <MdiOptions imageSrc={RedAlertIcon} />
                                    <UsedBytext>
                                        {t(
                                            'consignmentBilling.inventory.expired'
                                        )}
                                    </UsedBytext>
                                </div>
                                <UseByDate>{user.useByDate}</UseByDate>
                            </div>
                        ) : user.expiryStatus === 'minexpiry' ? (
                            // <LoTtext>{user.useByDate}</LoTtext>
                            <div>
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'flex-end',
                                        alignContent: 'center',
                                    }}
                                >
                                    <MdiOptions
                                        imageSrc={ClockAlertOutline}
                                        mr={'4px'}
                                    />
                                    <MaxExpirytext>
                                        {t(
                                            'consignmentBilling.inventory.useBy'
                                        )}
                                    </MaxExpirytext>
                                </div>
                                <MaxExpiryDate>{user.useByDate}</MaxExpiryDate>
                            </div>
                        ) : (
                            <LoTtext>{user.useByDate}</LoTtext>
                        )}
                    </ItemCardTextContainer>
                </GridContainer>
            ) : null}
        </div>
    );
}
